var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("rect",{"width":"36","height":"36","key":0}),React.createElement("path",{"stroke":"#084782","strokeLinecap":"round","strokeLinejoin":"round","d":"M20.9632353 20.9632353L30.1397059 30.1397059M23.3529412 14.1764706C23.3529412 9.10952941 19.2434118 5 14.1764706 5 9.10952941 5 5 9.10952941 5 14.1764706 5 19.2434118 9.10952941 23.3529412 14.1764706 23.3529412 19.2434118 23.3529412 23.3529412 19.2434118 23.3529412 14.1764706z","key":1})]));
}

Search.displayName = "Search";

Search.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36"};

module.exports = Search;

Search.default = Search;



//////////////////
// WEBPACK FOOTER
// ./src/app/icons/search.svg
// module id = 281
// module chunks = 0